import { Employee, Branch } from '../../types';

export interface TaeenFormState {
  passportOffice: string;
  vesselId: string;
  flag: string;
  ownerNationality: string;
  fromPort: string;
  currentLocation: string;
  selectedEmployeeIds: string[];
}

export function buildLetterHtml(
  form: TaeenFormState,
  vessel: Branch | undefined,
  selectedEmployees: Employee[]
): string {
  const today = new Date().toLocaleDateString('ar-EG', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const rows = selectedEmployees
    .map(
      (emp, i) => `
      <tr>
        <td style="border:1px solid #000;padding:6px 10px;text-align:center;">${emp.address || ''}</td>
        <td style="border:1px solid #000;padding:6px 10px;text-align:center;">${emp.birthDate ? new Date(emp.birthDate).toLocaleDateString('ar-EG') : ''}</td>
        <td style="border:1px solid #000;padding:6px 10px;text-align:center;">${emp.seamanBookNumber || ''}</td>
        <td style="border:1px solid #000;padding:6px 10px;text-align:center;">${emp.position || ''}</td>
        <td style="border:1px solid #000;padding:6px 10px;text-align:center;">${emp.name || ''}</td>
        <td style="border:1px solid #000;padding:6px 10px;text-align:center;">${i + 1}</td>
      </tr>`
    )
    .join('');

  const vesselName = vessel?.name || '';

  return `<!DOCTYPE html>
<html dir="rtl" lang="ar">
<head>
  <meta charset="UTF-8"/>
  <title>طلب تعيين بحارة</title>
  <style>
    @media print { body { margin: 0; } }
    body {
      font-family: 'Traditional Arabic', 'Arial', sans-serif;
      direction: rtl;
      text-align: right;
      padding: 40px;
      line-height: 2;
      font-size: 16px;
      color: #000;
    }
    .header { text-align: center; margin-bottom: 24px; }
    .header .company { font-size: 22px; font-weight: bold; color: #1e40af; }
    .date-line { text-align: left; margin-bottom: 16px; }
    .recipient { margin-bottom: 20px; font-weight: bold; font-size: 17px; }
    .body-text { margin-bottom: 20px; text-indent: 2em; }
    table { width: 100%; border-collapse: collapse; margin: 20px 0; }
    th { border: 1px solid #000; padding: 8px 10px; background: #e5e7eb; font-weight: bold; text-align: center; }
    .footer { margin-top: 36px; }
    .footer .thanks { text-align: center; font-weight: bold; margin-bottom: 30px; }
    .footer .sign { text-align: center; }
  </style>
</head>
<body>
  <div class="header">
    <div class="company">بترومارين لدعم المشاريع البحرية</div>
  </div>
  <div class="date-line">التاريخ: ${today}</div>
  <div class="recipient">السيد / مدير قسم جوازات ${form.passportOffice}</div>
  <div class="recipient">تحية طيبة وبعد ،،</div>
  <div class="body-text">
    الرجاء من سيادتكم الموافقة علي تعيين عدد (${selectedEmployees.length}) بحرى على الوحدة ${vesselName} التابعة لشركة بترومارين لدعم المشاريع البحرية والمسجلة تحت علم ${form.flag} وجنسية المالك ${form.ownerNationality} القادمة من ميناء ${form.fromPort} والمتواجدة حاليا ${form.currentLocation}
  </div>
  <div style="margin-bottom:8px;font-weight:bold;">وهم كالاتي :</div>
  <table>
    <thead>
      <tr>
        <th>العنوان</th>
        <th>تاريخ الميلاد</th>
        <th>رقم الجواز البحري</th>
        <th>الوظيفة</th>
        <th>الاسم</th>
        <th>م</th>
      </tr>
    </thead>
    <tbody>
      ${rows}
    </tbody>
  </table>
  <div class="footer">
    <div class="thanks">ولسيادتكم جزيل الشكر</div>
    <div class="sign">مقدمة لسيادتكم توكيل سيلفرسي</div>
  </div>
</body>
</html>`;
}
